export const ACCESS_DOMAINS = {
  api: sessionStorage.getItem("api_green") ? import.meta.env.APP_API_GREEN_DOMAIN : import.meta.env.APP_API_DOMAIN,
  app: import.meta.env.APP_APP_ORIGIN_DOMAIN,
  editor: sessionStorage.getItem("ws_green") ? import.meta.env.APP_COLLAB_SERVICE_GREEN : import.meta.env.APP_COLLAB_SERVICE,
  btApi: import.meta.env.APP_BT_API_DOMAIN,
  pdfExport: import.meta.env.APP_PDF_SERVICE_DOMAIN,
};
